import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'warning';

interface KioskButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
  large?: boolean;
}

/** KIOSK 主／次／警示按鈕。最小觸控高度 88px（見 index.css .k-btn）。 */
export function KioskButton({
  variant = 'primary',
  block = false,
  large = false,
  className,
  type = 'button',
  ...rest
}: KioskButtonProps): JSX.Element {
  const cls = [
    'k-btn',
    `k-btn--${variant}`,
    block ? 'k-btn--block' : '',
    large ? 'k-btn--lg' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <button type={type} className={cls} {...rest} />;
}
